import { render, staticRenderFns } from "./ScreenTwo.vue?vue&type=template&id=36918124&"
import script from "./ScreenTwo.vue?vue&type=script&lang=js&"
export * from "./ScreenTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports